<template>
    <div class="team-box">
        <div class="image-box">
            <img :src="planData.teamDto.imgUrl" />
        </div>
        <div>
            <div class="content-right-box">
                <!-- <div>
                    <div class="img-box">
                        <img src="@/assets/image/chushihua.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">124</span>
                            <span class="total-font">/343</span>
                        </div>
                        <span class="font-status">
                            排名
                        </span>
                    </div>
                </div> -->
                <div>
                    <div class="img-box">
                        <img src="@/assets/image/jiaojuan.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ planData.totalScore ? Number(planData.totalScore).toFixed(2) : '0' }}</span>
                        </div>
                        <span class="font-status">
                            {{$t("showLxRecord.ZF")}}
                        </span>
                    </div>
                </div>
            </div>
            <p>
                <el-tag size="mini">
                    {{$t("showLxRecord.TDMC")}}
                </el-tag>
                <span class="team-name" :title="planData.teamDto.teamName">{{ planData.teamDto.teamName }}</span>
            </p>
            <p>
                <el-tag size="mini">
                    {{$t("showLxRecord.DZXM")}}
                </el-tag>
                <span class="leader-name" :title="planData.teamDto.leaderName">
                    {{ planData.teamDto.leaderName }}
                </span>
            </p>
            <p>
                <el-tag size="mini">
                    {{$t("showLxRecord.LXSJ")}}
                </el-tag>
                <span class="status-text nowrap" :title="`${planData.teamDto.startTime} - ${planData.teamDto.submitTime}`">
                    {{ planData.teamDto.startTime}} - {{ planData.teamDto.submitTime }}
                </span>
            </p>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'teamBox',
    props:{
        planData: Object
    }
}
</script>
<style lang="scss" scoped>
.team-box{
    display: flex;
}
.image-box{
    width: 150px;
    height: 166px;
    margin-right: 16px;
    img{
        width: 150px;
        height: 166px;
    }
}
p{
    margin: 12px 0;
    @include flex();
    align-items: center;
    .team-name{
        margin: 0 8px 0 0;
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #0D141E;
        letter-spacing: 2px;
    }
    .icon-modify{
        color: #5397F7;
        font-size: 16px;
    }
    .icon-modify:hover{
        cursor: pointer;
        opacity: .8;
    }
    /deep/ .el-tag{
        margin-right: 16px;
    }
    .leader-name, .status-text{
        font-size: 14px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #5D646E;
    }
    .red{
        color: #F77981;
    }
}
.content-right-box{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img-box{
        width: 64px;
        height: 64px;
        opacity: 0.8;
        img{
            width: 100%;
        }
    }
    > div{
        display: flex;
        margin-right: 24px;
        flex: 1;
        margin-bottom: 0px;
        .text-box{
            margin: -8px 0 0 8px;
            .font-status, .font-title, .total-font{
                font-family: Hiragino Sans GB;
                font-weight: normal;
            }   
            .font-title{
                font-size: 40px;
                color: #5397F7;
            }
            .total-font{
                font-size: 16px;
                margin-left: 5px;
                color: #5D646E;
            }
            .font-status{
                font-size: 14px;
                color: #5D646E;
                margin-left: 6px;
            }
        }
    }
}
</style>